import { theme } from 'lib/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: theme.padding,
    gap: theme.padding,
  },
  logo: {
    alignItems: 'center',
    marginBottom: theme.grid,
  },
  textFieldContainer: {
    marginBottom: theme.padding,
  },
  textFieldInput: {
    borderRadius: 4,
    textAlign: 'center',
  },
});
